import { loggerScope } from "../parser/utils";
import { FunctionImplementation } from "../../nexus/function/function.types";
import { TrackingAsync } from "..";
import { onInit } from "@gr-exports/async/tracking";

const log = loggerScope.scope("defer");

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export interface ReleaseLock extends Disposable {
  /**
 *
 */
  (): boolean;
}

/**
 *
 *
 *
 */
export const locks = new Set<symbol | string | object>();

/**
 *
 *
 *
 *
 */
export function triggerInitIfReleased(): boolean {
  if (locks.size > 0) return false;
  log.info("All deferrations released, notifying tracking async namespace");
  onInit.dispatch({ retain: true });
  return true;
}

export const unlockInit = function unlockInit(lockToken) {
  log.info("Release init lock by:", lockToken);
  locks.delete(lockToken);

  return triggerInitIfReleased();
} satisfies FunctionImplementation<TrackingAsync["unlockInit"]>;

/**
 *
 */
export const lockInit = function lockInit(lockToken) {
  log.info("Lock init by", lockToken);
  locks.add(lockToken);

  const unlock: ReleaseLock = () => unlockInit(lockToken) as never;
  unlock[Symbol.dispose] = unlock;
  return unlock;
} satisfies FunctionImplementation<TrackingAsync["lockInit"]>;
